import { render, staticRenderFns } from "./PositionTypes.vue?vue&type=template&id=8469d354"
import script from "./PositionTypes.vue?vue&type=script&lang=js"
export * from "./PositionTypes.vue?vue&type=script&lang=js"
import style0 from "./PositionTypes.vue?vue&type=style&index=0&id=8469d354&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports